import { jsx as _jsx } from "react/jsx-runtime";
import Timeline from './components/Timeline/Timeline';
import './App.scss';
const App = () => {
    return (_jsx("div", { className: "App", children: _jsx(Timeline, {}) }));
};
export default App;
